import { useFormContext } from '@calendly/form'
import { pick } from 'lodash-es'
import { useMemo } from 'react'

import { useGetUserQuery } from 'common'
import { getMemberName } from 'components/event_type_edit'
import { getAvailabilityFromRule } from 'components/event_type_edit/utils/get_availability_from_rule'
import { useEventType } from 'features/event_type_provider'

import { filterEnabledMemberships } from '../../helpers'
import { findAvailabilityMembership } from '../helpers'

const getActiveSchedule = (availabilityMembership) => {
  const { ownerAvailabilityRules } = availabilityMembership
  if (!ownerAvailabilityRules?.rules) { return null }

  const activeSchedule = ownerAvailabilityRules.rules.find(({ id }) => id === availabilityMembership.activeAvailabilityRuleId)
  return getAvailabilityFromRule(activeSchedule)
}

export const useMembershipsWithActiveAvailability = () => {
  const { data: currentUser } = useGetUserQuery()
  const { isTeam } = useEventType()
  const { values: { memberships = [], event_type_memberships_attributes: etmAttrs } } = useFormContext()

  const activeMemberships = useMemo(
    () => (isTeam ? filterEnabledMemberships(memberships) : memberships),
    [isTeam, memberships]
  )

  return useMemo(() => (
    activeMemberships.map((membership) => {
      const availabilityMembership = findAvailabilityMembership(etmAttrs, membership)

      if (!availabilityMembership) { return null }

      const availabilityMembershipIndex = etmAttrs.indexOf(availabilityMembership)

      const availability = availabilityMembership.usingCustomHours
        ? availabilityMembership
        : getActiveSchedule(availabilityMembership)

      const memberName = getMemberName({ name: membership.name, user_uuid: membership.user_uuid }, currentUser)

      return {
        ...membership,
        memberName,
        formPath: `event_type_memberships_attributes.${availabilityMembershipIndex}`,
        ...pick(availability, ['availableHours', 'dateOverrides', 'timezone'])
      }
    }).filter(Boolean)
  ),
  [activeMemberships, currentUser, etmAttrs])
}
